import {
  ListItemButton,
  useTheme,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import React from "react";

import { SidebarMenuItemCollapseIcon } from "./SidebarMenuItemCollapseIcon";
import { SidebarMenuItemIcon } from "./SidebarMenuItemIcon";
import { SidebarMenuItemText } from "./SidebarMenuItemText";
import type { SidebarMenuItemRowProps } from "./types";

// Personalizza questi colori
const ACTIVE_BG = "#334155"; // Sfondo item selezionato (grigio più chiaro)
const HOVER_BG = "#293548"; // Sfondo hover (grigio medio)

export const SidebarMenuItemButton: React.FC<SidebarMenuItemRowProps> = (
  props
) => {
  const {
    item,
    openItems,
    setOpenItems,
    handleLogout,
    navigate,
    level = 0,
    selectedItem,
    setSelectedItem,
    collapsed = false,
    onMenuItemClick,
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const hasChildren = !!item.items?.length;
  const isLogout = item.text.toLowerCase() === "esci";
  const isSelected = selectedItem === item.text;
  const isExpanded = !!openItems[item.text];
  const itemPadding = collapsed
    ? theme.spacing(1)
    : theme.spacing(2 + level * 2);

  const handleClick = React.useCallback(() => {
    if (hasChildren)
      setOpenItems((prev) => ({ ...prev, [item.text]: !prev[item.text] }));
    else if (isLogout) {
      handleLogout();
      if (onMenuItemClick && isMobile) onMenuItemClick();
    } else if (item.path) {
      navigate(item.path);
      if (onMenuItemClick && isMobile) onMenuItemClick();
    }
    if (setSelectedItem) setSelectedItem(item.text);
  }, [
    hasChildren,
    setOpenItems,
    item,
    isLogout,
    handleLogout,
    navigate,
    setSelectedItem,
    isMobile,
    onMenuItemClick,
  ]);

  return (
    <Tooltip
      title={collapsed ? item.text : ""}
      placement="right"
      arrow
      disableHoverListener={!collapsed}
    >
      <ListItemButton
        onClick={handleClick}
        sx={{
          display: "flex",
          justifyContent: collapsed ? "center" : "space-between",
          overflowX: "hidden",
          pl: itemPadding,
          pr: collapsed ? 0 : 2,
          py: 1.2,
          minHeight: 48,
          mb: 0.5,
          mx: 1,
          borderRadius: 2,
          backgroundColor: isSelected ? ACTIVE_BG : "transparent",
          fontWeight: isSelected ? 600 : 500,
          "&:hover": {
            backgroundColor: isSelected ? ACTIVE_BG : HOVER_BG,
            transform: "translateX(2px)",
          },
        }}
      >
        <SidebarMenuItemIcon
          Icon={item.icon}
          collapsed={collapsed}
          isSelected={isSelected}
        />
        {!collapsed && (
          <SidebarMenuItemText text={item.text} isSelected={isSelected} />
        )}
        {hasChildren && !collapsed && (
          <SidebarMenuItemCollapseIcon isExpanded={isExpanded} />
        )}
      </ListItemButton>
    </Tooltip>
  );
};
